
import lazyload from "@/directives/lazyload";
import foxLogo from "@/assets/images/landing/svg/fox-color.svg";
import wrifLogo from "@/assets/images/landing/svg/wrif-color.svg";
import marketwatchLogo from "@/assets/images/landing/svg/marketwatch-color.svg";
import wralLogo from "@/assets/images/landing/svg/wral-color.svg";
import financeLogo from "@/assets/images/landing/svg/finance-color.svg";
import globeLogo from "@/assets/images/landing/svg/globe-color.svg";
import tretonianLogo from "@/assets/images/landing/svg/tretonian-color.svg";
import newsLogo from "@/assets/images/landing/svg/news-color.svg";
import breakingLogo from "@/assets/images/landing/svg/breaking-color.svg";
import tmcLogo from "@/assets/images/landing/svg/tmc-color.svg";

import foxGrey from "@/assets/images/landing/svg/fox-grey.svg";
import wrifGrey from "@/assets/images/landing/svg/wrif-grey.svg";
import marketwatchGrey from "@/assets/images/landing/svg/marketwatch-grey.svg";
import wralGrey from "@/assets/images/landing/svg/wral-grey.svg";
import financeGrey from "@/assets/images/landing/svg/finance-grey.svg";
import globeGrey from "@/assets/images/landing/svg/globe-grey.svg";
import tretonianGrey from "@/assets/images/landing/svg/tretonian-grey.svg";
import newsGrey from "@/assets/images/landing/svg/news-grey.svg";
import breakingGrey from "@/assets/images/landing/svg/breaking-grey.svg";
import tmcGrey from "@/assets/images/landing/svg/tmc-grey.svg";

import marketwatchImg from "@/assets/images/landing/img/marketwatch.png";
import wralImg from "@/assets/images/landing/img/wral.png";
import financeImg from "@/assets/images/landing/img/finance.png";
import globeImg from "@/assets/images/landing/img/globe.png";
import tretonianImg from "@/assets/images/landing/img/tretonian.png";
import newsImg from "@/assets/images/landing/img/news-img.png";
import breakingImg from "@/assets/images/landing/img/breaking-img.png";
import tmcImg from "@/assets/images/landing/img/tmc-img.png";
export default {
  data() {
    return {
      pageNumber: 0,
      lineLength: 0,
      imgListPosition: 0,
      lineMobile: null,
      imgListPositionMobile: null,
      imgListIndexMobile: 17,
      scrollBlock: null,
      scrollBlockMobile: null,
      greyLogoList: [
        foxGrey,
        wrifGrey,
        newsGrey,
        marketwatchGrey,
        wralGrey,
        financeGrey,
        globeGrey,
        tretonianGrey,
        breakingGrey,
        tmcGrey,
      ],
      featuredList: [
        {
          videoSrc: "https://www.youtube.com/embed/LYrl549ujvk",
          text:
            '“A story Fox 2 Detroit News did on the service <span class="span--text-bold">iFindCheaters.com</span>”',
          logo: foxLogo,
        },
        {
          videoSrc: "https://www.youtube.com/embed/2dj7DpmuxwY",
          text: `WRIF's Dave & Chuck the Freak mention <span class="span--text-bold">iFindCheaters.com </span>`,
          logo: wrifLogo,
        },
        {
          resourceSrc:
            "https://www.wfmz.com/news/pr_newswire/pr_newswire_technology/protect-relationship-integrity-with-high-tech-tools/article_17935900-29c9-5686-be0d-e99f51294464.html",
          resourceImg: newsImg,
          text: `69News (wfmz-tv) about <span class="span--text-bold">iFindCheaters.com </span>`,
          logo: newsLogo,
        },
        {
          resourceSrc:
            "https://www.marketwatch.com/press-release/protect-relationship-integrity-with-high-tech-tools-2021-05-14",
          resourceImg: marketwatchImg,
          text: `Market Watch about  <span class="span--text-bold">iFindCheaters.com </span>`,
          logo: marketwatchLogo,
        },
        {
          resourceSrc:
            "https://markets.financialcontent.com/wral/news/read/41349723/protect_relationship_integrity_with_high_tech_tools",
          resourceImg: wralImg,
          text: `WRAL about <span class="span--text-bold">iFindCheaters.com </span>`,
          logo: wralLogo,
        },
        {
          resourceSrc:
            "https://finance.yahoo.com/news/protect-relationship-integrity-high-tech-124400458.html",
          resourceImg: financeImg,
          text: `Yahoo!finance about <span class="span--text-bold">iFindCheaters.com </span>`,
          logo: financeLogo,
        },
        {
          resourceSrc:
            "https://fineglobe.news/uncategorized/protect-relationship-integrity-with-high-tech-tools/366334/",
          resourceImg: globeImg,
          text: `The Fine Globe about  <span class="span--text-bold">iFindCheaters.com </span>`,
          logo: globeLogo,
        },
        {
          resourceSrc:
            "https://www.trentonian.com/news/state/protect-relationship-integrity-with-high-tech-tools/article_002266b5-a07f-5ee0-aa61-be965a38c127.html",
          resourceImg: tretonianImg,
          text: `The Trentonian about <span class="span--text-bold">iFindCheaters.com </span>`,
          logo: tretonianLogo,
        },
        {
          resourceSrc:
            "https://www.tmcnet.com/usubmit/-protect-relationship-integrity-with-high-tech-tools-/2021/05/14/9369774.htm",
          resourceImg: breakingImg,
          text: `Breaking U.S News about <span class="span--text-bold">iFindCheaters.com </span>`,
          logo: breakingLogo,
        },
        {
          resourceSrc:
            "https://newsus.app/protect-relationship-integrity-with-high-tech-tools/",
          resourceImg: tmcImg,
          text: `TMCNET NEWS about  <span class="span--text-bold">iFindCheaters.com </span>`,
          logo: tmcLogo,
        },
      ],
    };
  },
  directives: {
    lazyload,
  },
  mounted() {
    this.scrollBlock = document.querySelector("#img-list-block");
    this.scrollBlockMobile = document.querySelector("#img-block-mobile");
  },
  methods: {
    changePageOnIcon(e) {
      this.pageNumber = +e.target.attributes.value.value;
      this.scrollBlock.scrollLeft = this.pageNumber * 108;
      this.scrollBlockMobile.scrollLeft = this.pageNumber * 84;
    },
    prevPage() {
      this.scrollBlock.scrollLeft -= 108;
      this.pageNumber--;
    },

    nextPage() {
      this.scrollBlock.scrollLeft += 108;
      this.pageNumber++;
    },
    prevPageMobile() {
      this.scrollBlockMobile.scrollLeft -= 84;
      this.pageNumber--;
    },

    nextPageMobile() {
      this.scrollBlockMobile.scrollLeft += 84;
      this.pageNumber++;
    },
  },
};
